import React,{useState, useEffect} from "react";
import "./advanced-case-search.scss";
import Select from "react-select";
import { McLoadingIndicator } from "@maersk-global/mds-react-wrapper/mc-loading-indicator";
import { DataGrid } from "@mui/x-data-grid";
import { CORE_URL, API_URL } from "../../services/api-config";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";
import { McOption, McSelect } from "@maersk-global/mds-react-wrapper";
import { set } from "date-fns";
import USER_LIST from "../../constants/user-list";
import EditIcon from "@mui/icons-material/Edit";
import EditSlaModal from './EditSlaModal';
import { Tooltip } from "@mui/material";
import MessagesModal from '../shared/MessagesModal';
import EmailViewModal from '../shared/EmailViewModal';
import CaseHistoryModal from './CaseHistoryModal';


const AdvancedCaseSearch = () => {
  
  // State for all filter options
  const [filterOptions, setFilterOptions] = useState({
    casenumber: [],
    casestatus: [],
    sla_status_name: [],
    caseassignedto: [],
    region_name: [],
    country_name: [],
    senderemail: [],
    shipmenttype: [],
    createddate: [],
    modifieddate: [],
    region_country_map: {},
  });

  // Fetch all filter options from backend on mount
  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const resp = await fetch(`${API_URL}/get_all_filter_options`);
        if (!resp.ok) throw new Error('Failed to fetch filter options');
        const data = await resp.json();
        setFilterOptions({
          casenumber: data.casenumber || [],
          casestatus: data.casestatus || [],
          sla_status_name: data.sla_status_name || [],
          caseassignedto: data.caseassignedto || [],
          region_name: data.region_name || [],
          country_name: data.country_name || [],
          senderemail: data.senderemail || [],
          shipmenttype: data.shipmenttype || [],
          createddate: data.createddate || [],
          modifieddate: data.modifieddate || [],
          region_country_map: data.region_country_map || {},
        });
      } catch (e) {
        console.error('Error fetching filter options:', e);
      }
    };
    fetchFilterOptions();
  }, []);
  const [cases, setCases] = useState([]);
  const [casesBackup, setCasesBackup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0); // zero-based
  const [pageSize, setPageSize] = useState(50);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
  const [rowCount, setRowCount] = useState(0);
 const [selectionModel, setSelectionModel] = useState([]);
 const [assignOwnerModel, setAssignOwnerModel] = useState(false);
 const [userAssign, setUserAssign] = useState();
 const [historyModalOpen, setHistoryModalOpen] = useState(false);
 const [historyLoading, setHistoryLoading] = useState(false);
 const [historyData, setHistoryData] = useState(null);
 const [selectedCaseNumber, setSelectedCaseNumber] = useState(null);
  // SLA edit modal state
  const [editSlaOpen, setEditSlaOpen] = useState(false);
  const [editSlaCase, setEditSlaCase] = useState(null); // store whole row for context
  const [newTargetSla, setNewTargetSla] = useState('');
  // Unread message modal state
  const [unreadModalOpen, setUnreadModalOpen] = useState(false);
  const [unreadModalData, setUnreadModalData] = useState(null);
  const [emailViewOpen, setEmailViewOpen] = useState(false);
  const [emailViewData, setEmailViewData] = useState(null);
  // Keys for localStorage persistence (now per-user). Legacy keys kept for migration.
  const updatedUserInfo = sessionStorage.getItem('userInfo');
  const parsedUserInfo = updatedUserInfo ? JSON.parse(updatedUserInfo) : {};
  const userEmailKeyPart = (parsedUserInfo?.email || 'default').toLowerCase();
  const FILTERS_STORAGE_KEY = `advancedCaseSearch.${userEmailKeyPart}.selectedFilters`;
  const SLA_FILTER_STORAGE_KEY = `advancedCaseSearch.${userEmailKeyPart}.slaStatusFilter`;
  const LEGACY_FILTERS_STORAGE_KEY = 'advancedCaseSearch.selectedFilters';
  const LEGACY_SLA_STORAGE_KEY = 'advancedCaseSearch.slaStatusFilter';

  const defaultSelectedFilters = {
    casenumber: [],
    casestatus: [],
    caseassignedto: [],
    country_name: [],
    region_name: [],
    senderemail: [],
    shipmenttype: [],
    createddate: [],
    modifieddate: [],
  };

  // Synchronous initial load from storage so navigation back retains filters.
  const initStoredFilters = (() => {
    try {
      let stored = localStorage.getItem(FILTERS_STORAGE_KEY) || localStorage.getItem(LEGACY_FILTERS_STORAGE_KEY);
      let storedSla = localStorage.getItem(SLA_FILTER_STORAGE_KEY) || localStorage.getItem(LEGACY_SLA_STORAGE_KEY);
      let parsedFilters = defaultSelectedFilters;
      let parsedSla = { slastatus: [] };
      if (stored) {
        const tmp = JSON.parse(stored);
        if (tmp && typeof tmp === 'object') parsedFilters = { ...defaultSelectedFilters, ...tmp };
      }
      if (storedSla) {
        const tmpSla = JSON.parse(storedSla);
        if (tmpSla && typeof tmpSla === 'object') parsedSla = { slastatus: Array.isArray(tmpSla.slastatus) ? tmpSla.slastatus : [] };
      }
      return { parsedFilters, parsedSla };
    } catch (e) {
      console.warn('Init stored filters parse error', e);
      return { parsedFilters: defaultSelectedFilters, parsedSla: { slastatus: [] } };
    }
  })();

  const [selectedFilters, setSelectedFilters] = useState(initStoredFilters.parsedFilters);
  const [filteredCountryOptions, setFilteredCountryOptions] = useState([]);
  const [slaStatusFilter,setSlaStatusFilter]=useState(initStoredFilters.parsedSla);

  // Initial fetch after state is set
  useEffect(() => {
  // Initial load: get total count then first page
  refreshWithFilters(selectedFilters, slaStatusFilter, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reload filters if user email key part changes (e.g., after login) from 'default' to actual email.
  useEffect(() => {
    if (userEmailKeyPart === 'default') return; // nothing to do until real user email known
    try {
      let stored = localStorage.getItem(FILTERS_STORAGE_KEY);
      let storedSla = localStorage.getItem(SLA_FILTER_STORAGE_KEY);
      if (!stored && !storedSla) return; // no user-specific data yet
      const newFilters = stored ? { ...defaultSelectedFilters, ...(JSON.parse(stored) || {}) } : selectedFilters;
      const newSla = storedSla ? { slastatus: Array.isArray(JSON.parse(storedSla)?.slastatus) ? JSON.parse(storedSla).slastatus : [] } : slaStatusFilter;
      setSelectedFilters(newFilters);
      setSlaStatusFilter(newSla);
      fetchCases(newFilters, newSla);
    } catch (e) {
      console.warn('User-specific filter reload failed', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEmailKeyPart]);

//  Persist filters whenever they change
  useEffect(() => {
    try {
      localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(selectedFilters));
    } catch (e) {
      console.warn('Unable to persist selectedFilters', e);
    }
  }, [selectedFilters]);

  useEffect(() => {
    try {
      localStorage.setItem(SLA_FILTER_STORAGE_KEY, JSON.stringify(slaStatusFilter));
    } catch (e) {
      console.warn('Unable to persist slaStatusFilter', e);
    }
  }, [slaStatusFilter]);
  // updatedUserInfo already processed above
const isAllExceptionlSelected = selectionModel.length > 0 && selectionModel.every(id => {
 
const selectedCase = cases[id-1]
    return selectedCase && selectedCase.casestatus && selectedCase.casestatus.toLowerCase() === 'exception';
  })

  const handleFilterChange = (filterName, selectedOption, isMulti=false) => {
    setSelectedFilters(prev => ({
      ...prev,
      [filterName]: isMulti ? (Array.isArray(selectedOption) ? selectedOption.map(o => o.value) : []) : (selectedOption ? [selectedOption.value] : [])
    }));
   
  };
 
  useEffect(() => {
    const selectedRegions = selectedFilters.region_name;
    const allCountries = Array.isArray(filterOptions.country_name) ? filterOptions.country_name : [];
    const regionMap = filterOptions.region_country_map || {};
    let options = [];
    if (Array.isArray(selectedRegions) && selectedRegions.length > 0 && regionMap && Object.keys(regionMap).length > 0) {
      // Union of countries from all selected regions
      const unionSet = new Set();
      selectedRegions.forEach(reg => {
        const countries = regionMap[reg] || [];
        countries.forEach(c => unionSet.add(c));
      });
      options = Array.from(unionSet).filter(Boolean).sort().map(country => ({ value: country, label: country }));
    } else {
      options = allCountries.filter(Boolean).sort().map(country => ({ value: country, label: country }));
    }
    setFilteredCountryOptions(options);
    if (!selectedRegions || selectedRegions.length === 0) {
      setSelectedFilters(prev => prev.country_name.length ? { ...prev, country_name: [] } : prev);
    }
  }, [selectedFilters.region_name, filterOptions.country_name, filterOptions.region_country_map]);
const handleSubmit = async () => {

  if (!userAssign) {
    alert("Please select an owner.");
    return;
  }
  if (!selectionModel.length) {
    alert("Please select at least one case.");
    return;
  }

  try {
    setLoading(true);
const casenumberMap = selectionModel.map(id=>cases[id - 1]?.casenumber)
    const payload = {
      casenumbers: casenumberMap,
      caseassignedto: userAssign,
      
    };

  const res = await fetch(`${API_URL}/assign_case_owner`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Assign failed: ${res.status} ${text}`);
    }


    setCases(prev => prev.map(c =>
      casenumberMap.includes(c.casenumber)
        ? { ...c, caseassignedto: userAssign }
        : c
    ));

   
    setAssignOwnerModel(false);
    setUserAssign();
    setSelectionModel([]);

    // Re-fetch to ensure backend sync
    await fetchCases();
  } catch (err) {
    console.error("Assign owner error:", err);
    alert("Failed to assign owner. Please try again.");
  } finally {
    setLoading(false);
  }
}

  const fetchCases = (filtersOverride = selectedFilters, slaOverride = slaStatusFilter, pageOverride = page, pageSizeOverride = pageSize) => {
  const isEvent = (obj) => !!(obj && typeof obj === 'object' && 'nativeEvent' in obj);
  let effectiveFilters = filtersOverride || selectedFilters;
  if (isEvent(effectiveFilters)) {
    effectiveFilters = selectedFilters;
  }
  const effectiveSla = isEvent(slaOverride) ? slaStatusFilter : (slaOverride || slaStatusFilter);
  setLoading(true);
  let queryParts = [];
  Object.entries(effectiveFilters).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length > 0) {
      queryParts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v.join(','))}`);
    } else if (!Array.isArray(v) && v) {
      queryParts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    }
  });
  const paginationParams = `limit=${encodeURIComponent(pageSizeOverride)}&offset=${encodeURIComponent(pageOverride * pageSizeOverride)}`;
  const unreadParam = `include_unread=true`;
  const countOnlyParam = `count_only=false`;
  const minimalFieldsParam = `minimal_fields=false`;
  const fullQuery = `${API_URL}/get_all_case_information${queryParts.length ? `?${queryParts.join('&')}&${paginationParams}&${unreadParam}&${countOnlyParam}&${minimalFieldsParam}` : `?${paginationParams}&${unreadParam}&${countOnlyParam}&${minimalFieldsParam}`}`;
  fetch(fullQuery)
      .then((res) => res.json())
  .then((data) => {
        // Helper: parse textual target SLA like '24 hrs', '1 day', '48h' into hours
        const parseTargetSlaToHours = (val) => {
          if (val == null) return null;
          const s = String(val).toLowerCase().trim();
          const hourMatch = s.match(/^(\d+)\s*(h|hr|hrs|hour|hours)$/);
          if (hourMatch) return Number(hourMatch[1]);
          const dayMatch = s.match(/^(\d+)\s*(d|day|days)$/);
          if (dayMatch) return Number(dayMatch[1]) * 24;
          const minuteMatch = s.match(/^(\d+)\s*(m|min|mins|minute|minutes)$/);
          if (minuteMatch) return Number(minuteMatch[1]) / 60;
          // If value includes 'h' without space like 24h
          const compactHour = s.match(/^(\d+)h$/);
          if (compactHour) return Number(compactHour[1]);
          // Pure number: treat as minutes (business feedback) -> convert to hours
          const num = Number(s);
          if (!isNaN(num)) return num / 60;
          return null;
        };

 
        const computeSlaStatus = (row) => {
          const targetHours = parseTargetSlaToHours(row.countryslatime || row.targetsla);
          // If no target SLA we treat as met but still only show label for Approved/Rejected.
          let consumedHours = parseIntervalToHours(row.slatimecosumed);
          if (consumedHours == null) {
            // Cannot evaluate — leave blank to avoid misleading status.
            return '';
          }
          if (consumedHours < 0) consumedHours = Math.abs(consumedHours);
          const isBreached = targetHours != null ? consumedHours > targetHours : false;
          if (isBreached) return 'SLA Breached';
          // Only show SLA Met for Approved / Rejected
          const status = (row.casestatus || '').toLowerCase();
            if (status === 'approved' || status === 'rejected') {
              return 'SLA Met';
            }
          return '';
        };

        // Backend returns { items, total, limit, offset }
        const mappedCases = Array.isArray(data?.items)
          ? data.items.map((row, idx) => {
              const slastatus = computeSlaStatus(row);
              return {
                id: idx,
                ...row,
                modifiedBy: row.modifiedBy ?? row.modifiedby ?? '',
                slastatus: slastatus
              };
            })
          : [];
          let modifiedData = mappedCases
        if(effectiveSla.slastatus.length>0){
          modifiedData = modifiedData.filter(item => effectiveSla.slastatus.includes(item.slastatus));
        }
        setRowCount(Number(data?.total) || modifiedData.length);
        setCases(modifiedData);
        setCasesBackup(modifiedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error('API Error:', err);
        setLoading(false);
      });
  };

 const handleClearFilters = () => {
  setSelectedFilters(defaultSelectedFilters);
  // Clear persisted storage
  try {
    localStorage.removeItem(FILTERS_STORAGE_KEY);
    localStorage.removeItem(SLA_FILTER_STORAGE_KEY);
    // Also clear any old legacy keys lingering
    localStorage.removeItem(LEGACY_FILTERS_STORAGE_KEY);
    localStorage.removeItem(LEGACY_SLA_STORAGE_KEY);
  } catch (e) {
    console.warn('Unable to clear stored filters', e);
  }

  setSlaStatusFilter({slastatus: []});
  setPage(0);
  // Use refreshWithFilters to reset row count and pagination
  refreshWithFilters(defaultSelectedFilters, {slastatus: []}, 0);
};

  const refreshWithFilters = async (filters, slaFilter, targetPage = 0, targetPageSize = pageSize) => {
    try {
      setLoading(true);
      const effectiveFilters = filters || selectedFilters;
      setPage(targetPage);
      fetchCases(effectiveFilters, slaFilter, targetPage, targetPageSize);
    } catch (e) {
      console.error('Refresh with filters error', e);
      setLoading(false);
    }
  };

 

  // Fetch case history from backend and open modal
  const fetchCaseHistory = async (casenumber) => {
    try {
      setSelectedCaseNumber(casenumber);
      setHistoryLoading(true);
      setHistoryData(null);
      setHistoryModalOpen(true);

      const res = await fetch(`${API_URL}/get_case_history?casenumber=${encodeURIComponent(casenumber)}`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Failed to fetch history: ${res.status} ${text}`);
      }
      const json = await res.json();
      // Expect { casenumber: '...', history: [...] }
      // Normalize to an array and sort by datetime (most recent first)
      const rawHistory = json.history ?? json ?? [];
      const historyArray = Array.isArray(rawHistory) ? rawHistory.slice() : [];
      historyArray.sort((a, b) => {
        const da = a?.datetime ? new Date(a.datetime) : new Date(0);
        const db = b?.datetime ? new Date(b.datetime) : new Date(0);
        return db - da; // descending: latest first
      });
      setHistoryData(historyArray);
    } catch (err) {
      console.error('Error fetching case history:', err);
      setHistoryData({ error: err.message || 'Unknown error' });
    } finally {
      setHistoryLoading(false);
    }
  };




  const handleExportCases = () => {
    if (!cases || cases.length === 0) {
      alert("No cases available to export");
      return;
    }

    const headers = Object.keys(cases[0]);
    const csvRows = [];


    csvRows.push(headers.join(","));

    cases.forEach((row) => {
      const values = headers.map((header) => {
        const val = row[header] ?? "";
      
        return `"${String(val).replace(/"/g, '""')}"`;
      });
      csvRows.push(values.join(","));
    });
    const csvData = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = url;
    link.download = "cases_export.csv";
    link.click();
    window.URL.revokeObjectURL(url);
  };

 const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f8ff" : "white", 
      color: state.isFocused ? "#0078d7" : "black", 
      cursor: "pointer",
        fontSize: "12px",
        }),
        control: (provided) => ({
          ...provided,
          borderColor: "#cfcfcf",
          fontSize: "12px",
          "&:hover": {
            borderColor: "#0078d7", 
          },
        }),
        singleValue: (provided) => ({
          ...provided,
          fontSize: "12px",
        }),
        input: (provided) => ({
          ...provided,
          fontSize: "12px",
        }),
        placeholder: (provided) => ({
          ...provided,
          fontSize: "12px",
        }),
        menu: (provided) => ({
          ...provided,
          fontSize: "12px",
        }),
      };
 

const parseIntervalToHours = (val) => {
  if (val == null) return null;
  if (typeof val === "number") {
    return val / 3600;
  }


  if (typeof val === "object") {
    const days = Number(val.days || 0);
    const seconds = Number(val.seconds || 0);
    const micros = Number(val.microseconds || 0);
    const totalSeconds = days * 86400 + seconds + micros / 1e6;
    return totalSeconds / 3600;
  }

  const s = String(val).trim();

  const iso = s.match(/P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?/);
  if (iso) {
    const days = Number(iso[1] || 0);
    const hours = Number(iso[2] || 0);
    const mins = Number(iso[3] || 0);
    const secs = Number(iso[4] || 0);
    return days * 24 + hours + mins / 60 + secs / 3600;
  }

  const dayMatch = s.match(/(\d+)\s*day/);
  const timeMatch = s.match(/(\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))?/);
  if (timeMatch) {
    const days = Number(dayMatch?.[1] || 0);
    const hours = Number(timeMatch[1]);
    const mins = Number(timeMatch[2]);
    const secs = Number(timeMatch[3]);
    return days * 24 + hours + mins / 60 + secs / 3600;
  }


  const num = Number(s);
  if (!Number.isNaN(num)) {
    return num / 3600;
  }

  return null;
};


const formatSlaTimeConsumed = (val) => {
  const hours = parseIntervalToHours(val);
  if (hours == null) return "";
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    return `${days} day${days !== 1 ? "s" : ""}`;
  }
  if (hours < 1) {
    const minutesExact = hours * 60;
    if (minutesExact >= 1) {
      return `${Math.round(minutesExact)} min`;
    }
    const seconds = Math.round(hours * 3600);
    return `${seconds} sec`;
  }
  return `${Number(hours.toFixed(2))} hrs`;
};

// Format various datetime inputs to 'YYYY-MM-DD HH:MM:SS'
const formatDateTime = (val) => {
  if (val == null) return "";

  // If it's already a Date
  if (val instanceof Date && !Number.isNaN(val.getTime())) {
    const y = val.getFullYear();
    const m = String(val.getMonth() + 1).padStart(2, '0');
    const d = String(val.getDate()).padStart(2, '0');
    const hh = String(val.getHours()).padStart(2, '0');
    const mm = String(val.getMinutes()).padStart(2, '0');
    const ss = String(val.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
  }

  const s = String(val).trim();

  // Try quick ISO-like match: YYYY-MM-DDTHH:MM:SS (ignore fractional seconds)
  const isoMatch = s.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})/);
  if (isoMatch) {
    return `${isoMatch[1]} ${isoMatch[2]}`;
  }

  // Fallback: try Date parse and format
  const parsed = new Date(s);
  if (!Number.isNaN(parsed.getTime())) {
    const y = parsed.getFullYear();
    const m = String(parsed.getMonth() + 1).padStart(2, '0');
    const d = String(parsed.getDate()).padStart(2, '0');
    const hh = String(parsed.getHours()).padStart(2, '0');
    const mm = String(parsed.getMinutes()).padStart(2, '0');
    const ss = String(parsed.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
  }

  // As a last resort return the original value
  return s;
};

  // Helper to escape HTML when generating export content
  const escapeHtml = (unsafe) => {
    if (unsafe == null) return '';
    return String(unsafe)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };
  
const columns = [
  { field: 'casenumber', headerName: 'Case Number', width: 150, renderCell: (params) => (
      <div>
        <a
          href="#"
          title={params.value ? `Show case history for ${params.value}` : 'Show case history'}
          onClick={(e) => {
            e.preventDefault();
            // Prevent the DataGrid row from being selected when the link is clicked
            e.stopPropagation();
            const cn = params.value;
            if (cn) {
              // fetch and open modal
              fetchCaseHistory(cn);
            }
          }}
          onKeyDown={(e) => {
            // support keyboard activation without toggling row selection
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              const cn = params.value;
              if (cn) fetchCaseHistory(cn);
            }
          }}
          style={{ color: '#0078d7', cursor: 'pointer', textDecoration: 'underline' }}
        >
          {params.value}
        </a>
      </div>
    ) },
    { field: 'unread_count', headerName: 'Email Alert', width: 120, renderCell: (params) => {
      const count = Number(params.value) || 0;
      const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        cursor: count > 0 ? 'pointer' : 'default',
        position: 'relative',
        marginTop: '12px'
      };

      const iconStyle = {
        color: '#707070', // default grey icon color; badge shows green when unread
        fontSize: '20px',
        position: 'relative',
        zIndex: 1
      };

      const badgeStyle = {
        position: 'absolute',
        top: '6px',
        right: '32px',
        minWidth: '18px',
        height: '18px',
        padding: '0 5px',
        borderRadius: '9px',
        backgroundColor: '#25D366',
        color: 'white',
        display: count > 0 ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '11px',
        fontWeight: 600,
        zIndex: 2
      };

      const shownCount = count > 99 ? '99+' : String(count);

      // Always render an icon. If count > 0 show badge too (green) and title indicates unread count.
      const row = params.row || {};
      const titleText = count > 0 ? `${count} unread message${count !== 1 ? 's' : ''}` : 'Last message';
      // If there are no messages at all for this case, don't render the icon (show dash)
      const hasAnyMessage = (count > 0) || Boolean(row.last_message_time) || Boolean(row.from) || Boolean(row.subject) || Boolean(row.to) || Boolean(row.sender_mail_address) || Boolean(row.to_recipients);
      if (!hasAnyMessage) {
        return (
          <div style={containerStyle} title="">
            <div style={{ width: '100%', textAlign: 'center', color: '#707070', fontSize: '12px' }}>-</div>
          </div>
        );
      }

      return (
        <div
          style={containerStyle}
          title={titleText}
          onClick={async (e) => {
            e.stopPropagation();

            const casenumber = row.casenumber;

            // Fetch messages for this case from backend
            try {
              setHistoryLoading(true);
              const resp = await fetch(`${API_URL}/get_case_messages?casenumber=${encodeURIComponent(casenumber)}`);
              if (!resp.ok) {
                const text = await resp.text().catch(() => resp.statusText || 'error');
                throw new Error(`Failed to fetch messages: ${resp.status} ${text}`);
              }
              const json = await resp.json();

              // Normalize messages to an array and sort newest-first by the best available timestamp
              const messages = Array.isArray(json.messages) ? json.messages.slice() : [];
              const getMessageTime = (m) => {
                const t = m?.receive_timestamp || m?.createddate || m?.receive_time || m?.timestamp || m?.datetime;
                const d = t ? new Date(String(t)) : new Date(0);
                return isNaN(d.getTime()) ? new Date(0) : d;
              };
              messages.sort((a, b) => getMessageTime(b) - getMessageTime(a));

              // Always show the full conversation (newest first) in the modal
              setUnreadModalData({ casenumber, messages });
              setUnreadModalOpen(true);

              // If there were unread messages, mark them as read in backend and update UI to remove badge count
              if ((json.messages || []).some(m => m.unread)) {
                try {
                  const markResp = await fetch(`${API_URL}/mark_case_messages_read`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ casenumber })
                  });
                  if (markResp.ok) {
                    // update local cases state to remove unread_count for this case only (keep icon)
                    setCases(prev => prev.map(c => c.casenumber === casenumber ? { ...c, unread_count: 0 } : c));
                  } else {
                    console.error('Failed to mark messages read', markResp.status);
                  }
                } catch (err) {
                  console.error('Error marking messages read', err);
                }
              }

            } catch (err) {
              console.error('Error fetching case messages:', err);
              setUnreadModalData({ casenumber: row.casenumber, messages: [], error: err.message || String(err) });
              setUnreadModalOpen(true);
            } finally {
              setHistoryLoading(false);
            }
          }}
        >
          <div style={badgeStyle} aria-hidden={false}>{shownCount}</div>
          <McIcon icon="comment-dots" style={iconStyle} />
        </div>
      );
  }, headerClassName: 'email-alert-header' },  
  { field: 'casestatus', headerName: 'Case Status', width: 150 },
   { field: 'subject', headerName: 'Email Subject', width: 450 },
  { field: 'slastatus', headerName: 'SLA Status', width: 150 },
  { field: 'caseassignedto', headerName: 'Case Assigned To', width: 180 },
   { field: 'casestatusreason', headerName: 'Case Status Reason', width: 250 }, 
  { field: 'region_name', headerName: 'Region', width: 150 },
  { field: 'country_name', headerName: 'Country', width: 150 },
  { field: 'createddate', headerName: 'Created Date', width: 200, renderCell: (params) => (
      <div>
        {params.value?.split("T")[0]}
      </div>
    ),},
  { field: 'modifieddate', headerName: 'Modified Date', width: 200, renderCell: (params) => (
      <div>
        {params.value?.split("T")[0]}
      </div>
    ),},
      { field: 'modifiedBy', headerName: 'Modified By', width: 150 },
       { field: 'caseprocessingdatetime', headerName: 'Case Processing Time', width: 150 ,renderCell: (params) => (
      <div>
        {params.value?.replace("T", " ").split('.')[0]}
      </div>
    ) },
  { field: 'shipmenttype', headerName: 'Shipment Type', width: 150 },
  // { field: 'countryslatime', headerName: 'Country SLA Time', width: 180 },
  { field: 'senderemail', headerName: 'Sender Email', width: 200 },
  { field: 'inboundemailid', headerName: 'Inbound Email ID', width: 200 },
    { field: 'countryslatime', headerName: 'Target SLA', width: 160, renderCell: (params) => (
      <div style={{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'flex-start',
        gap:'12px',
        width:'100%',
        whiteSpace:'nowrap',
        padding:'10px 4px'
      }}>
        <span style={{display:'inline-flex',alignItems:'center',lineHeight:1}}>{params.value ?? ''}</span>
        {params.row.region_name == 'NAM'&& parsedUserInfo.email == 'neelaveeramanikandan.devarasu@maersk.com' && (
          <Tooltip title="Edit SLA" arrow><div style={{cursor:'pointer',display:'flex',alignItems:'center'}} onClick={(e)=>{e.stopPropagation(); setEditSlaCase(params.row); setNewTargetSla(''); setEditSlaOpen(true);}}><EditIcon fontSize="small" /></div></Tooltip>
        )}
         {params.row.region_name == 'LAM'&& (parsedUserInfo.email == 'tanya.catalbas@maersk.com'|| parsedUserInfo.email == 'neigeah.dellezo@maersk.com' || parsedUserInfo.email == 'josephcaliwan.cordero@maersk.com' || parsedUserInfo.email == 'jeffrey.pelovello@maersk.com' || parsedUserInfo.email == 'aileen.parcia.asor@maersk.com') && (
          <Tooltip title="Edit SLA" arrow><div style={{cursor:'pointer',display:'flex',alignItems:'center'}} onClick={(e)=>{e.stopPropagation(); setEditSlaCase(params.row); setNewTargetSla(''); setEditSlaOpen(true);}}><EditIcon fontSize="small" /></div></Tooltip>
        )}
        {params.row.region_name == 'APA'&& parsedUserInfo.email == 'dhanashree.d.kale@maersk.com' && (
          <Tooltip title="Edit SLA" arrow><div style={{cursor:'pointer',display:'flex',alignItems:'center'}} onClick={(e)=>{e.stopPropagation(); setEditSlaCase(params.row); setNewTargetSla(''); setEditSlaOpen(true);}}><EditIcon fontSize="small" /></div></Tooltip>
        )}
         {(params.row.region_name == 'EUR') && (parsedUserInfo.email == 'mary.lagsac@maersk.com' || parsedUserInfo.email == 'bhupathi.rekha@maersk.com' || parsedUserInfo.email == 'gerry.lyn.benigno-santos@maersk.com') && (
          <Tooltip title="Edit SLA" arrow><div style={{cursor:'pointer',display:'flex',alignItems:'center'}} onClick={(e)=>{e.stopPropagation(); setEditSlaCase(params.row); setNewTargetSla(''); setEditSlaOpen(true);}}><EditIcon fontSize="small" /></div></Tooltip>
        )}
         
      </div>
    ) },
    { field: 'slastartdatetime', headerName: 'SLA Start Datetime', width: 180 ,renderCell: (params) => (
      <div>
        {params.value?.replace("T", " ").split('.')[0]}
      </div>
    ) },
  { field: 'slaenddatetime', headerName: 'SLA End Datetime', width: 180 ,sortable: true, renderCell: (params) => (
      <div>
        {params.value?.replace("T", " ").split('.')[0]}
      </div>
    ) },
  
     
  // { field: 'responsereceived', headerName: 'Response Received', width: 180 ,renderCell: (params) => (
  //     <div style={{ marginTop: '15px' }}>
  //       {params.value === true ? <McIcon icon="comment-dots" /> : ''}
  //     </div>
  //   )},
    { field: 'slatimecosumed', headerName: 'SLA Time Consumed', width: 180, renderCell: (params) => (
        <div>
          {params?.value < 0 ?  `-${formatSlaTimeConsumed(params.value * -1)}`: formatSlaTimeConsumed(params.value)}
        </div>
      ) },
  // Unread count column - show green comment-dots when > 0, tooltip with count on hover, open modal on click
  
  
  { field: 'last_message_time', headerName: 'Last Message Time', width: 150 },
];

  // Created/Modified Date options coming from backend filterOptions (date-only strings)
  const todayISODate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
  const createdDateOptions = (Array.isArray(filterOptions.createddate) ? filterOptions.createddate : [])
    .filter(Boolean)
    .sort((a, b) => b.localeCompare(a))
    .map(d => ({ value: d, label: d === todayISODate ? "Today" : d }));
  // Always keep "Today" as the first option and avoid duplicates
  const createdDateOptionsFinal = [{ value: todayISODate, label: "Today" }, ...createdDateOptions.filter(o => o.value !== todayISODate)];

  const modifiedDateBase = (Array.isArray(filterOptions.modifieddate) ? filterOptions.modifieddate : [])
    .filter(Boolean)
    .sort((a, b) => b.localeCompare(a))
    .map(d => ({ value: d, label: d === todayISODate ? "Today" : d }));
  // Always keep "Today" as the first option and avoid duplicates
  const modifiedDateOptions = [{ value: todayISODate, label: "Today" }, ...modifiedDateBase.filter(o => o.value !== todayISODate)];

  return (
    <>
    <div >
      <div
        style={{
          fontSize: "14px",
          background: "#f7f7f7",
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 5px",
          alignItems: "center"
        }}
      >
        <span>Get started by filtering the cases as per user preferences.</span>
        <div style={{ display: "flex", gap: "10px" }}>
        
          
          <McButton
            label="Export Cases"
            appearance="secondary"
            click={handleExportCases}
          />
        </div>
      </div>
 <div style={{ padding: "10px" }}>
        
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              marginBottom: "20px",
              border: "1px solid #cfcfcf",
              padding: "10px",
              backgroundColor: "#F0F0F0"
            }}
          >
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Case Number"
                  options={filterOptions.casenumber.map(casenumber => ({ value: casenumber, label: casenumber }))}
                  value={selectedFilters.casenumber.map(v => ({ value: v, label: v }))}
                  isMulti
                  isClearable
                  onChange={(value) => handleFilterChange("casenumber", value, true)}
                />
            </div>
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Case Status"
                  options={filterOptions.casestatus.map(casestatus => ({ value: casestatus, label: casestatus }))}
                  value={selectedFilters.casestatus.map(v => ({ value: v, label: v }))}
                  isMulti
                  isClearable
                  onChange={(value) => handleFilterChange("casestatus", value, true)}
                />
            </div>
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="SLA Status"
                  options={filterOptions.sla_status_name.map(slastatus => ({ value: slastatus, label: slastatus }))}
                  value={slaStatusFilter.slastatus?.map(v => ({ value: v, label: v }))}
                  isMulti
                  isClearable
                  onChange={(value) => {
                    setSlaStatusFilter(prev => ({
                      ...prev,
                      ['slastatus']:  Array.isArray(value) ? value.map(o => o.value) : []
                    }));
                  }}
                />
            </div>
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Case Assigned To"
                  options={filterOptions.caseassignedto.map(caseassignedto => ({ value: caseassignedto, label: caseassignedto }))}
                  value={selectedFilters.caseassignedto.map(v => ({ value: v, label: v }))}
                  isMulti
                  isClearable
                  onChange={(value) => handleFilterChange("caseassignedto", value, true)}
                />
            </div>
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Region"
                  options={filterOptions.region_name.map(region_name => ({ value: region_name, label: region_name }))}
                  value={selectedFilters.region_name.map(v => ({ value: v, label: v }))}
                  isMulti
                  isClearable
                  onChange={(value) => handleFilterChange("region_name", value, true)}
                />
            </div>
            <div style={{ width: "200px", position: 'relative' }}>
              <Select
                styles={customStyles}
                placeholder="Country"
                options={selectedFilters.region_name.length ? filteredCountryOptions : []}
                value={selectedFilters.country_name.map(v => ({ value: v, label: v }))}
                isMulti
                isClearable
                onChange={(value) => {
                  if (!selectedFilters.region_name.length) return; // ignore selections until region chosen
                  handleFilterChange('country_name', value, true);
                }}
                noOptionsMessage={() => !selectedFilters.region_name.length
                  ? <span style={{ color: 'red' }}>Please select a value in Region first</span>
                  : (filteredCountryOptions.length ? 'No countries for selected region(s)' : 'No countries found')}
              />
              {/* {!selectedFilters.region_name.length && (
                <div style={{ marginTop: '4px', fontSize: '11px', color: 'red' }}>
                  Please select a value in Region first
                </div>
              )} */}
            </div>
           
           <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Shipment Type"
                  options={[...new Set(casesBackup.map(ref => ref.shipmenttype))]
                    .filter(Boolean)
                    .map(shipmenttype => ({ value: shipmenttype, label: shipmenttype }))}
                  value={selectedFilters.shipmenttype.map(v => ({ value: v, label: v }))}
                  isMulti
                  isClearable
                   onChange={(value) => handleFilterChange("shipmenttype", value, true)}
                />
            </div>
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Created Date"
                  options={createdDateOptionsFinal}
                  value={selectedFilters.createddate.map(v => ({ value: v, label: v === todayISODate ? 'Today' : v }))}
                  isMulti
                  isClearable
                  onChange={(value) => handleFilterChange("createddate", value, true)}
                />
            </div>
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Modified Date"
                  options={modifiedDateOptions}
                  value={selectedFilters.modifieddate.map(v => ({ value: v, label: v === todayISODate ? 'Today' : v }))}
                  isMulti
                  isClearable
                  onChange={(value) => handleFilterChange("modifieddate", value, true)}
                />
            </div>
            <div style={{ width: "200px" }}>
                <Select
                  styles={customStyles}
                  placeholder="Sender Email"
                  options={[...new Set(casesBackup.map(ref => ref.senderemail))]
                    .filter(Boolean)
                    .map(senderemail => ({ value: senderemail, label: senderemail }))}
                  value={selectedFilters.senderemail.map(v => ({ value: v, label: v }))}
                  isMulti
                  isClearable
                   onChange={(value) => handleFilterChange("senderemail", value, true)}
                />
            </div>
            

        <McButton
  label="Apply Filter"
  appearance="primary"
  click={() => refreshWithFilters(selectedFilters, slaStatusFilter, 0)}
/> 
<McButton
            label="Clear Filters"
            appearance="primary"
            click={handleClearFilters}
          />
      <McButton
            label="Assign Owner"
            appearance="primary"
            disabled={!isAllExceptionlSelected}
            click={() => setAssignOwnerModel(true)}
          />
         <McModal
                 heading="Please select the Owner to assign the case"
                 closed={() => {
                   setAssignOwnerModel(false);
                 }}
                 open={assignOwnerModel}
                 width="40vw"
                 height="40vh"
               >
          <div className="nextActioncontent">
                 
                  
                     <McSelect
                       label="UserList"
                       placeholder="Select reason"
                       value={userAssign}
                       optionselected={(e) => setUserAssign(e.target.value)}
                     >
                      {USER_LIST.map(user => (
                        <McOption key={user.apmId} value={user.email}>
                          {user.apmId +  " (" + user.email + ")"}
                        </McOption>
                      ))}
                     </McSelect>
               
                   
                   <div className="submitButton">
                     <McButton
                       appearance="secondary"
                       fit="medium"
         
                       click={() => handleSubmit()}
                     >
                       Submit
                     </McButton>
                   </div>
                 </div>
          </McModal>
          </div>


         {loading ? (
           <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '400px',
          flexDirection: 'column' 
        }}>
  <McLoadingIndicator
    appearance="primary"
    style={{ fontSize: "36px", transform: "scale(2)", marginBottom: "16px" }}
  /></div>
) : (
  <div className="DatagridStyle" >
    <DataGrid
      checkboxSelection={true}
      rows={cases.map((row, index) => ({ ...row, id: (page * pageSize) + index + 1 }))}
      columns={columns}
      pagination
      paginationMode="server"
      rowCount={rowCount}
      paginationModel={paginationModel}
      onPaginationModelChange={(newModel) => {
        // newModel has shape { page, pageSize }
        setPaginationModel(newModel);
        // keep legacy page/pageSize in sync for other logic in this component
        const newPage = Number(newModel.page || 0);
        const newPageSize = Number(newModel.pageSize || pageSize);
        if (newPage !== page || newPageSize !== pageSize) {
          setPage(newPage);
          setPageSize(newPageSize);
          // fetch data for requested page
          refreshWithFilters(selectedFilters, slaStatusFilter, newPage, newPageSize);
        }
      }}
      rowsPerPageOptions={[25,50,100,200]}
      disableSelectionOnClick
      getRowClassName={(params) => {
        const classes = [];
        const slaStatus = (params.row?.slastatus || '').trim();
        if (slaStatus === 'SLA Met') {
          classes.push('row-sla-met');
        }
        const endRaw = params.row?.slaenddatetime;
        if (endRaw) {
          const end = new Date(String(endRaw));
          if (!isNaN(end.getTime())) {
            const now = new Date();
            const diffMs = end.getTime() - now.getTime();
            const hoursUntilEnd = diffMs / 3600000; // ms -> hours
            if (hoursUntilEnd <= 24 && hoursUntilEnd >= 0 && slaStatus !== 'SLA Met') {
              classes.push('row-sla-approaching');
            }
          }
        }
        return classes.join(' ');
      }}
  rowSelectionModel={selectionModel}                 
        onRowSelectionModelChange={(newModel,row) => {
          setSelectionModel(Array.isArray(newModel) ? newModel : [newModel]);
        }}
      slots={{
        ColumnHeaderCheckbox: () => null,
      }}
   initialState={{
    sorting: {
      sortModel: [{ field: 'slaenddatetime', sort: 'desc' }],
    },
  }}
      sx={{
        fontFamily: "Maersk Text",
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "#E2F3FB",
        },
        "& .MuiDataGrid-columnHeader": {
          backgroundColor: "#E2F3FB",
        },
        "& .MuiDataGrid-columnHeader.email-alert-header": {
          backgroundColor: "#A1D1E8 !important",
        },
        "& .MuiDataGrid-virtualScrollerContent": {
          backgroundColor: "white",
        },
          "& .MuiDataGrid-cell": {
            fontSize: "12px",
          },
          "& .MuiDataGrid-columnHeader": {
            fontSize: "12px",
          },
      }}
    />
  </div>
)}
        </div>
      </div>
      <CaseHistoryModal
        open={historyModalOpen}
        onClose={() => { setHistoryModalOpen(false); setHistoryData(null); setSelectedCaseNumber(null); }}
        selectedCaseNumber={selectedCaseNumber}
        historyData={historyData}
        historyLoading={historyLoading}
        formatDateTime={formatDateTime}
        setHistoryLoading={setHistoryLoading}
        setUnreadModalData={setUnreadModalData}
        setUnreadModalOpen={setUnreadModalOpen}
        setEmailViewData={setEmailViewData}
        setEmailViewOpen={setEmailViewOpen}
      />
      <MessagesModal
        open={unreadModalOpen}
        onClose={() => { setUnreadModalOpen(false); setUnreadModalData(null); }}
        caseNumber={unreadModalData?.casenumber}
        initialData={unreadModalData}
      />
      <EmailViewModal
        open={emailViewOpen}
        onClose={() => { setEmailViewOpen(false); setEmailViewData(null); }}
        caseNumber={emailViewData?.casenumber}
        initialData={emailViewData}
      />
      <EditSlaModal
        open={editSlaOpen}
        onClose={()=>{setEditSlaOpen(false); setEditSlaCase(null); setNewTargetSla('');}}
        currentTargetSla={editSlaCase?.countryslatime || ''}
        newTargetSla={newTargetSla}
        onChangeNewTargetSla={(e)=> setNewTargetSla(e.target.value)}
        onSubmit={()=>{
          // Placeholder submit: close modal. Real implementation can call backend then refresh rows.
          setEditSlaOpen(false);
          // Update local state optimistic (optional):
          if(editSlaCase){
            setCases(prev => prev.map(c => c.casenumber === editSlaCase.casenumber ? {...c, countryslatime: newTargetSla } : c));
          }
          setEditSlaCase(null);
          setNewTargetSla('');
        }}
      />
    </>
  );
};

export default AdvancedCaseSearch;
